<script setup>
import ShipmentNotificationListener from '@/components/shipment/ShipmentNotificationListener.vue'
import DefaultLayoutWithVerticalNav from './components/DefaultLayoutWithVerticalNav.vue'

const { layoutAttrs, injectSkinClasses } = useSkins()

injectSkinClasses()
</script>

<template>
  <DefaultLayoutWithVerticalNav v-bind="layoutAttrs">
    <!-- Real-time parcel updates listener -->
    <ShipmentNotificationListener />

    <RouterView v-slot="{ Component }">
      <!-- Pre-2026-05-10 this used a v-if="!isLoading" gate combined with
           @vue:mounted="resolveComponent(...)". The mount handler flipped
           isLoading=true → unmounted the component → flipped back to false
           → re-rendered → onMounted fired AGAIN. Every page in the app
           double-mounted, every API call ran twice. Pages have their own
           loading UI; the layout-level spinner was both buggy and unneeded. -->
      <component :is="Component" />
    </RouterView>
  </DefaultLayoutWithVerticalNav>
</template>

<style lang="scss">
// As we are using `layouts` plugin we need its styles to be imported
@use "@layouts/styles/default-layout";
</style>
